<a (click)="onClick($event)" href="#">
  <div class="service-card-container">
    <div [id]="id" class="buttonCard selectType">
      <div [style.background-image]="'url(' + imageUrl + ')'" class="icon"></div>
      <div class="title">{{ title }}</div>
      <div class="content">
        <p class="service-card-text">{{ content }}</p>
        <div aria-hidden="true" class="service-card-select-placeholder"></div>
      </div>
      <div class="row center buttonArea">
        <button class="save" type="button">{{ buttonText }}</button>
      </div>
    </div>
  </div>
</a>
